import { memo, useMemo } from 'react';
import styled from '@emotion/styled';
import { Space, Tag } from 'antd';
import { formatNumber } from 'utils/numberFormat';
import { useTranslate } from '@tolgee/react';
import SafeImage from 'components/SafeImage';

type ItemContentProps = {
  product: Conversation.Product;
  conversation: Conversation.Conversation;
};

const ItemContent = memo((props: ItemContentProps) => {
  const { product, conversation } = props;
  const { t } = useTranslate();
  const {
    imageUrl: [imageUrl] = [],
    recentConsulting,
    isPreOrder,
    itemName: name,
    skuLowPrice: lowPrice,
    originalHighPrice: originalPrice,
    skuHighPrice: highPrice,
    unit = 'Rp',
  } = product;

  const { channel } = conversation;
  return (
    <Content>
      <span>
        <Image hasSmallPic="both" src={imageUrl} alt="product" />
        {recentConsulting && <b>{t('product.recentRecommend')}</b>}
      </span>
      <div>
        <h4 title={name}>
          {isPreOrder ? (
            <Tag color="green" title={t('trade.预购商品')}>
              {t('trade.预购商品')}
            </Tag>
          ) : null}
          <span>{name}</span>
        </h4>
        {useMemo(() => {
          if (channel === 'LAZADA' && lowPrice === 0 && lowPrice === highPrice) {
            return <p>{`${unit} ${formatNumber(originalPrice, '0,0.00')}`}</p>;
          }

          return (
            <PriceWrapper align="center">
              <p>
                {lowPrice === highPrice
                  ? `${unit} ${formatNumber(lowPrice, '0,0.00')}`
                  : `${unit} ${formatNumber(lowPrice, '0,0.00')} - ${unit} ${formatNumber(
                      highPrice,
                      '0,0.00',
                    )}`}
              </p>
              {originalPrice !== highPrice && (
                <del>{`${unit} ${formatNumber(originalPrice, '0,0.00')}`}</del>
              )}
            </PriceWrapper>
          );
        }, [channel, lowPrice, highPrice, originalPrice, unit])}
      </div>
      {/*<ItemLink>*/}
      {/*  <LinkOutlined />*/}
      {/*</ItemLink>*/}
    </Content>
  );
});

const Image = styled(SafeImage)`
  width: 64px;
  height: 64px;
`;

const Content = styled.div`
  display: flex;
  align-items: flex-start;
  position: relative;
  cursor: pointer;
  height: 66px;
  border: 1px solid rgba(240, 242, 245, 1);
  > span {
    position: relative;
    flex: 0 0 64px;
    height: 64px;
    margin-right: 10px;
    border-right: 1px solid rgba(240, 242, 245, 1);
    /* overflow: hidden; */
    > b {
      position: absolute;
      font-weight: 500;
      left: 0;
      bottom: 0;
      width: 100%;
      line-height: 16px;
      font-size: 12px;
      color: #fff;
      background: var(--main-color);
      opacity: 0.8;
    }
  }
  > div {
    flex: 1 0 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 11px 0;
    overflow: hidden;
    > * {
      margin: 0;
      font-size: 12px;
    }
    > h4 {
      font-size: 14px;
      color: #232426;
      display: flex;
      .ant-tag {
        border: none;
        color: #00bf69;
        margin-right: 2px;
        max-width: 40px;
        padding: 0 4px;
        font-size: 12px;
        flex-shrink: 0;
        align-items: center;
        position: initial;
      }
      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 18px;
      }
    }
  }
  > section {
    display: none;
  }
  //&:hover {
  //  background: #f0f2f5;
  //  > section {
  //    display: block;
  //  }
  //}
`;

const PriceWrapper = styled(Space)`
  font-size: 12px;
  padding: 4px 0;
  del {
    margin: 0;
    color: #b5b9bf;
  }
  p {
    color: var(--fett-colors-price);
    margin: 0;
  }
`;

export default ItemContent;
